import { getListPipelines } from './getListPipelines'
import { postRefreshJob } from './postRefreshJob'
import { getDashboard } from "./getDashboard"
import { getLeadsDashboardCardData } from './getLeadsDashboardCardData'
import generateCSV from './generateCSV'
import generatePDF from './generatePDF'
import generateIndividualPDF from './generateIndividualPDF'

export const Dashboard = {
    getListPipelines,
    postRefreshJob,
    getDashboard,
    generateCSV,
    generatePDF,
    generateIndividualPDF,
    getLeadsDashboardCardData
}
